import { Button, styled } from '@mui/material';

import { AppDialog, BaseDialogProps } from '@/components';

interface ConfirmationDialogProps extends BaseDialogProps {
  title?: string;
  description?: string;
  cancelText?: string;
  confirmText?: string;
  preWrapWhiteSpace?: boolean;
  onCancel: () => void;
  onConfirm?: () => void;
}

const Root = styled(AppDialog)(() => ({
  '& .MuiDialog-container': {
    zIndex: 1400,
  },
  '& .MuiBackdrop-root': {
    zIndex: 1399,
  },
  '& .MuiDialog-paper': {
    minWidth: 420,
    maxWidth: 600,
    zIndex: 1400,
  },
  '& .MuiDialogActions-root': {
    borderTop: '1px solid #0000001f',
  },
}));

export const ConfirmationDialog = ({
  title,
  description,
  cancelText = 'Cancel',
  confirmText = 'Ok',
  onCancel,
  onConfirm,
  preWrapWhiteSpace = false,
  ...rest
}: Omit<ConfirmationDialogProps, 'onClose'>) => {
  const hasDescription = Boolean(description?.trim());
  const Body = hasDescription ? (
    <div
      className="btnDescription"
      dangerouslySetInnerHTML={{ __html: description ?? '' }}
      style={{ whiteSpace: preWrapWhiteSpace ? 'pre-wrap' : 'normal' }}
    ></div>
  ) : null;

  const Footer = () => {
    return (
      <>
        <Button
          variant="outlined"
          onClick={onCancel}
          size="large"
          color="inherit"
        >
          {cancelText}
        </Button>

        <Button
          variant="contained"
          color="error"
          className="btnConfirm"
          onClick={onConfirm}
        >
          {confirmText}
        </Button>
      </>
    );
  };

  return (
    <Root
      {...rest}
      title={title}
      onClose={onCancel}
      transitionDuration={{ enter: 0, exit: 0 }}
      body={Body}
      footer={<Footer />}
    />
  );
};
